var $ = jQuery;
$(function() {
    $('.covid-ways-to-help > li > a').click(function(e) {
        e.preventDefault();

        $('.covid-ways-to-help > li').each(function(){
            $(this).removeClass('active');
        });

        $('.more-details > div').each(function() {
            $(this).removeClass('active');
        });

        var to_open = $(this).attr('href');

        $(this).parent().addClass('active');

        $('.more-details').find(to_open).addClass('active');
    });
});